import React from "react";
import "../../Cards.css";
import "../../App.css";
import ScrollableList from "../../Components/ScrollableList";
import ArtistCard from "../../Components/Cards/ArtistCard";
import { SectionProps } from "../types";
import i18n from "../../Translations";
import { useNavigate } from "react-router-dom";
import {
  ALGOLIA_ARTISTS_INDEX_NAME,
  ALGOLIA_ASCENDING_SUFFIX,
} from "../../Constants";

const BrowseArtists: React.FC<SectionProps> = ({
  collection,
  imageClass = "",
}) => {
  const navigate = useNavigate();

  const viewAllAction = () => {
    navigate("/content/browse-artists", {
      state: {
        index: `${ALGOLIA_ARTISTS_INDEX_NAME}${ALGOLIA_ASCENDING_SUFFIX}`,
        content_type: "music",
        title: i18n.t("titles.browseArtists"),
        facetFilters: ["flags.musician:true"],
        contentDisplay: "artist",
        attributesToRetrieve: ["id", "display_name", "photo"],
      },
    });
  };

  return (
    <div className="categories-margin">
      {collection.length ? (
        <ScrollableList
          itemClassName={`card-container ${collection.length > 0 && "hover"}`}
          title={i18n.t("titles.browseArtists")}
          viewAllAction={viewAllAction}
        >
          {collection.map((item: any) => {
            return (
              <div key={item.id}>
                <ArtistCard item={item} />
              </div>
            );
          })}
        </ScrollableList>
      ) : null}
    </div>
  );
};

export default BrowseArtists;
